import $http from '@/libs/axios'

export default class AdminUsersApi {
  static async delete(id: number) {
    return (await $http.delete(`admin/users/${id}`)).data
  }

  static async detachPage(id: number, pageId: number) {
    return (await $http.get(`admin/users/detach-page/${id}/${pageId}`)).data
  }

  static async updateUser(id: number, data: any) {
    return (await $http.post(`admin/users/update/${id}`, data)).data
  }
}
